import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { AbstractControl, FormBuilder } from "@angular/forms";
import { ConfirmService } from "@app/services";
import { DatabseBackupService } from "@app/services";
import { MatDialog } from "@angular/material";
import { ExportModalComponent } from "@app/components/_shared/export-modal/export-modal.component";
import { HistoryFilter } from "@app/models";
import { TranslationService } from "@app/services/translate.service";

@Component({
  selector: "app-database-backups",
  templateUrl: "./database-backups.component.html",
  styleUrls: ["./database-backups.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class DatabaseBackupsComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  readonly formControl: AbstractControl;

  fileList: any = [];
  dataSource: MatTableDataSource<String>;

  startDate: Date;
  endDate: Date;
  filterValues: any;
  filters: string;

  products: string[];
  stores: string[];
  clients: string[];
  historyFilters: HistoryFilter[] = [];
  defaultValue = "All";
  filterDictionary = new Map<string, string>();

  displayedColumns: string[] = ["filename", "actions"];
  displaySelectColumns: string[] = ["filename", "actions"];

  constructor(
    private databaseBackupService: DatabseBackupService,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private translationService: TranslationService,
    private confirmService: ConfirmService,
  ) {
    this.matIconRegistry.addSvgIcon(
      "custom-svg-icon", // Icon name to use in your template
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/export-icon.svg",
      ),
    );
  }

  ngOnInit() {
    this.getBackups();
  }

  getBackups() {
    this.databaseBackupService.getAll().subscribe(async (files) => {
      this.fileList = files.map((item) => {
        return {
          filename: item,
        };
      });
      this.dataSource = new MatTableDataSource<String>(this.fileList);
    });
  }

  createNewBackup() {
    this.databaseBackupService.create().subscribe(async (res) => {
      this.getBackups();
      this.downloadBackup(0, { filename: res });
    });
  }

  /* Table actions*/
  deleteBackup(index: number, file) {
    let confirmDialog = this.confirmService.openDialog(
      "Êtes-vous sûr de vouloir supprimer ce fichier ?",
    );
    confirmDialog.afterClosed().subscribe((res) => {
      if (res) {
        const data = this.dataSource.data;
        data.splice(index, 1);
        this.dataSource.data = data;
        this.databaseBackupService.delete(file.filename).subscribe();
      }
    });
  }

  downloadBackup(index: number, file) {
    this.databaseBackupService
      .download(file.filename)
      .subscribe(async (res) => {
        // const downloadUrl = window.URL.createObjectURL(new Blob([res]));
        // const link = document.createElement("a");
        // link.href = downloadUrl;
        // link.setAttribute("download", file.filename);
        // document.body.appendChild(link);
        // link.click();
        // link.remove();

        const blob = new Blob([res], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = file.filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  openDialog() {
    this.dialog.open(ExportModalComponent, {
      width: "400px",
      data: {
        columns: this.displaySelectColumns,
        rowData: this.dataSource.filteredData,
        submit: (data: any) => {},
      },
    });
  }

  translate(key: string): string {
    return this.translationService.translate(key, "fr"); // Change 'fr' to switch languages
  }
}
